import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineItemSelect from '../inputs/InlineItemSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


class EffectiveItemPriceGuidance extends Component {
  constructor(props) {
    super(props);
    const { initialValues } = props;
    this.initialState = {
      percent: initialValues.percent || 0.25,
      item_ids: initialValues.item_ids ? _.join(initialValues.item_ids) : '',
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
    _.bindAll(this, 'onSubmit', 'onChange', 'onReset');
  }

  onChange(item_ids) {
    this.setState({
      item_ids
    });
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.onSubmit({
      kind: 'effective_item_price',
      regions: _.filter(this.state.regions),
      value: {
        percent: parseFloat(this.state.percent),
        item_ids: _.filter(_.map(this.state.item_ids.split(','), val => parseInt(val, 10)), val => val),
      }
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineItemSelect
          value={this.state.item_ids}
          onChange={this.onChange}
          include_all={false}
          include_any={false}
        />
        <InlineInputNumber
          label='Discount Percentage'
          description='Amount to discount off of each item'
          displayFormat='percent'
          value={this.state.percent}
          onChange={value => this.setState({ percent: value })}
        />
      </RuleForm>
    );
  }
}

EffectiveItemPriceGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

EffectiveItemPriceGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default EffectiveItemPriceGuidance;
